import React from 'react';

import { SystemMessage } from 'react-chat-elements';
import PropTypes from 'prop-types';

export default function NotificationMessage({ message }) {
  return (
    <SystemMessage
      text={<div dangerouslySetInnerHTML={{ __html: message.text }} />}
    />
  );
}

NotificationMessage.propTypes = {
  message: PropTypes.object.isRequired,
};
